import { ReactNode, useState } from "react";

const SliderBeforeAndAfter = ({ image1, image2, text1, text2, rightCol = null }: 
    { 
        image1: string,
        image2: string,
        text1: string ,
        text2: string,
        rightCol?: ReactNode
    }
) => {
    const [sliderValue, setSliderValue] = useState(50);

    const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSliderValue(Number(e.target.value));
    };
    return (
        <section className={`flex xl:flex-nowrap flex-wrap gap-x-14  ${rightCol ? 'xl:mb-[216px] mb-10' : 'mb-[32px]'}`}>
            <div className={`relative ${rightCol ? 'xl:max-w-[60%] max-w-full' : 'max-w-[100%]'} w-full mx-auto overflow-hidden ${rightCol ? 'xl:h-auto h-[450px]' : 'aspect-[16/10] h-auto'}`}>
                <div className="absolute inset-0 z-10">
                    <img
                        srcSet={image1}
                        alt="Before"
                        className="object-cover object-center w-full h-full"
                    />
                    <div className="bg-[#0057A2] font-inter py-2 md:px-6 px-3 text-white absolute right-4 top-4 z-10 md:text-[18px] text-[12px] font-bold uppercase">{text1}</div>

                </div>

                <div
                    className="absolute inset-0 z-10"
                    style={{
                        clipPath: `inset(0 ${100 - sliderValue}% 0 0)`,
                    }}
                >
                    <div className="bg-[#0057A2] font-inter py-2 md:px-6 px-3 text-white absolute left-4 top-4 z-10 md:text-[18px] text-[12px] font-bold uppercase">{text2}</div>

                    <img
                        srcSet={image2}
                        // fill
                        alt="After"
                        className="object-cover object-center w-full h-full"
                    />
                </div>
                <div className="before-after-slide-wrapper">
                    <div className="indicator items-center justify-center" style={{ left: `${sliderValue}%` }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="26" viewBox="0 0 52 26" fill="none">
                            <path d="M38 2L49 13L38 24" stroke="#0057A2" strokeWidth="3" />
                            <path d="M14 24L3 13L14 2" stroke="#0057A2" strokeWidth="3" />
                        </svg>
                    </div>
                    <input
                        type="range"
                        min="0"
                        max="100"
                        value={sliderValue}
                        onChange={handleSliderChange}
                        className="before-after-slide"
                    />
                </div>
            </div>
            {rightCol != null &&
                rightCol
            }
        </section>
    );

}

export default SliderBeforeAndAfter;